<div class="flex w-full mt-5 pr-2">
  <modus-label class="text-xs grow">{{ translations.blendIntensity.text }}</modus-label>
  <modus-switch
    id="3d-settings-classification-intensity-toggle"
    [formControl]="blendIntensityControl"
  ></modus-switch>
</div>

@if (showIntensitySettings()) {
  <sd-scan-3d-intensity
    [scan3dStyle]="scan3dStyle()"
    (styleChange)="onStyleChange($event)"
    class="mb-2"
  ></sd-scan-3d-intensity>
}

@if (hasClassifications()) {
  <sd-classification-graph
    [classifications]="classifications()"
    [activeClassification]="activeClassification()"
    (activeClassificationChanged)="setActiveClassification($event)"
    class="flex mt-1 h-[235px]"
  ></sd-classification-graph>
  <ol class="mt-3">
    @for (item of classifications(); track item.classificationScheme.id) {
      <li
        (mouseover)="setActiveClassification(item)"
        (mouseout)="setActiveClassification()"
        (focus)="setActiveClassification(item)"
        (blur)="setActiveClassification()"
        [ngClass]="{ 'bg-gray-0': isActiveClassification(item) }"
        class="flex items-center text-xs p-y-2 pr-2 mb-2 hover:bg-gray-0 border-y border-gray-1 border-opacity-40"
        tabindex="0"
      >
        <button
          id="3d-settings-classification-item-visible-toggle"
          class="min-w-8"
          modus-icon-button
          (click)="changeVisibility(item)"
        >
          <md-icon
            class="!text-xl"
            [ngClass]="{ 'opacity-60': !item.classificationScheme.visible }"
            >{{ item.classificationScheme.visible ? 'visibility_on' : 'visibility_off' }}</md-icon
          >
        </button>
        <span class="grow overflow-hidden text-ellipsis whitespace-nowrap pl-1 pr-1">
          {{ item.classificationScheme.name }}
        </span>
        <span modus-tooltip="{{ item.percentage | percentage: 2 }}">{{
          item.percentage | percentage: 0
        }}</span>

        <div class="ml-2 h-4 w-9 flex-shrink-0">
          <sd-color-picker
            [color]="item.classificationScheme.rgba"
            [dialogPosition]="'top-left'"
            [dialogSize]="'medium'"
            (colorChanged)="changeColor($event, item)"
            (toggleChanged)="colorPickerToggle($event)"
          ></sd-color-picker>
        </div>
      </li>
    }
  </ol>
  @if (unallocatedClassificationCount(); as count) {
    @if (count > 0) {
      <modus-label class="text-xs flex grow justify-center italic">
        {{ unallocatedClassificationText() }}
      </modus-label>
    }
  }
} @else {
  {{ translations.noData.text }}
}
